<template>
  <div class="container" id="container">
    <div class="header DIN-Bold">
      <h2>Privacy Policy</h2>
    </div>
    <div class="box SFUITEXT-REGULAR">
      <p>Guangzhou Shishan Technology Co., Ltd. is committed to protecting the personal data relating to you and respecting your privacy.
      <br>Please read this Privacy Policy carefully to understand our policies and practices regarding your personal data and how we process it. This Privacy Policy applies to Guangzhou Shishan Technology Co., Ltd.’s games, applications, websites and related services (each category is collectively referred to as the “Service” or “Game”, “Application”, “Website”).
      <br>This Privacy Policy explains how we collect, use, protect and/or disclose end user ("you" or "your") information”) , or otherwise process your personal information when you use our services.</p>
      <h2>1. Information Collection</h2>
      <p>
        The Application acquires the information you supply when you download and use the Application. The Service Provider may also use the information you provided them to contact you from time to time to provide you with important information, required notices and marketing promotions.
        <br><br>
        <br>When players use our Game, we may collect certain information, including but not limited to: Device information: such as device type, operating system version, and unique device identifiers. Gameplay data: including in-game activities, progress, and interactions.
        <br>Location data: if permitted by the player for location-based features.
        <br>Contact information: if provided voluntarily by the player for account registration or support requests.
        <br>Other information: such as IP addresses, cookies, and analytics data.
        <br><br>
        This Application does not gather precise information about the location of your mobile device.
      </p>
      <h2>2. Use of Information</h2>
      <p>
        We may use the collected information for the following purposes:
        <br>- To provide and improve the Game experience.
        <br>- To personalize player experiences and optimize gameplay.
        <br>- To analyze trends, track player behavior.
        <br>- To communicate with players, respond to inquiries, and provide support.
        <br>- To prevent fraud, protect against abuse, and ensure the security of our Game.
        <br>- To comply with legal obligations and enforce our policies.
      </p>
      <h2>3. Information Sharing</h2>
      <p>
        The Service Provider may share your information with third parties in the ways that are described in this privacy statement. Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service.
        <br><br>
        <br>Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data.
        <br>The Service Provider may disclose User Provided and Automatically Collected Information: as required by law, such as to comply with a subpoena or similar legal process;
        <br>when they believe in good faith that disclosure is necessary to protect their rights, protect their safety or the safety of others, investigate fraud, or respond to a government request;
        <br>  with their trusted service providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
      </p>
      <h2>4. Player Rights</h2>
      <p>You can halt all collection of information by the Application easily by uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>
      <h2>5. Data Retention</h2>
      <p>
        We will retain player information for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. If you'd like the Service Provider to delete User Provided Data that you have provided via the Application, please contact them at shbraingames@outlook.com and we will respond in a reasonable time. Please note that some or all of the User Provided Data may be required in order for the Application to function properly.
      </p>
      <h2>6. Children</h2>
      <p>
        The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
        <br><br>
        The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (shbraingames@outlook.com) so that they will be able to take the necessary actions.
      </p>
      <h2>7. Security</h2>
      <p>
        The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect the information we process and maintain. For example, we limit access to this information to authorized employees and contractors who need to know that information to operate, develop or improve their applications. Please be aware that, although we endeavor to provide reasonable security for the information we process and maintain, no security system can prevent all potential security breaches.
      </p>
      <h2>8. Changes</h2>
      <p>
        We reserve the right to update this Privacy Policy at any time. Players will be notified of any changes through the Game or other appropriate channels. Continued use of the Game after the effective date of the revised Privacy Policy constitutes acceptance of the changes.
        <br><br>
        This privacy policy is effective as of 2024-04-08
      </p>
      <h2>9. Your Consent</h2>
      <p>
        By using the Application, you are giving your consent to the Service Provider processing of your information as set forth in this Privacy Policy now and as amended by us. "Processing,” means using cookies on a computer/handheld device or using or touching information in any way, including, but not limited to, collecting, storing, deleting, using, combining and disclosing information.
      </p>
      <h2>10. Contact us</h2>
      <p>If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at shbraingames@outlook.com.</p>
    
    </div>
    <div class="footer">
      <div class="footer_menu">
        <a @click="toPage('/home')">Home</a>
        <a @click="toPage('/privacy.html')">Privacy Policy</a>
        <a @click="toPage('/terms.html')">Terms of Service</a>
      </div>
      <p>Copyright © 2024.Guangzhou Shishan Technology Co., Ltd. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
    name:"privacyPage",
    mounted(){
      document.getElementById('container').scrollIntoView({ behavior: 'smooth' });
    },
    methods:{
      // 跳转页面
      toPage(path){
        
        this.$router.push({ 'path': path }).catch((err)=>{console.log(err);});
        window.removeEventListener('scroll', this.getScrollHeight)
      },
    }
}
</script>

<style lang="scss" scoped>
.box{
  width: 80%;
  margin: 50px auto;
  max-width: 1350px;
  min-width: 400px;
  text-align: justify;
  padding: 0 20px;
  h2{
    margin: 50px 0 30px;
  }
}
.header{
  height: 120px;
  background-color: #000;
  color: #fff;
  line-height: 120px;
}
.footer{
    width: 100%;
    background-color: #000;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    .footer_menu{
      font-family: "SFUITEXT-REGULAR";
      width: 400px;
      display: flex;
      justify-content: space-evenly;
      a{
        cursor: pointer;
        font-size: 18px;
        color: #B0E0FC;}
    }
    p{
      font-size: 21px;
      color: #fff;
    }
  }
</style>